import React from 'react';
import { Calendar } from 'primereact/calendar';
import { SelectButton } from 'primereact/selectbutton';

const WorkHistoryForm = ({ isOpen, onClose, onSubmit, formData, setFormData, isEditing }) => {
    if (!isOpen) return null;

    const modeOptions = [
        { label: 'Đầy đủ', value: 'date' },
        { label: 'Tháng/Năm', value: 'month' },
        { label: 'Chỉ Năm', value: 'year' }
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleDateChange = (name, dateObj) => {
        let dateString = '';
        if (dateObj) {
            const yyyy = dateObj.getFullYear();
            const mm = String(dateObj.getMonth() + 1).padStart(2, '0');
            const dd = String(dateObj.getDate()).padStart(2, '0');
            dateString = `${yyyy}-${mm}-${dd}`;
        }
        handleChange({ target: { name, value: dateString } });
    };

    const getDateFormat = (accuracy) => {
        if (accuracy === 'year') return 'yy';
        if (accuracy === 'month') return 'mm/yy';
        return 'dd/mm/yy';
    };

    return (
        <div className="modal-overlay" style={{ zIndex: 1000 }}>
            <div className="modal-box form-modal-box" style={{ maxHeight: '90vh', overflowY: 'auto' }}>
                <div className="modal-header">
                    <h3>{isEditing ? "Cập nhật Quá trình công tác" : "Thêm mới Quá trình công tác"}</h3>

                    <button
                        className="close-btn"
                        onClick={onClose}
                        style={{ fontSize: '24px', lineHeight: '1', display: 'flex', alignItems: 'center' }}
                    >
                        &times;
                    </button>
                </div>

                <div className="modal-body" style={{ padding: '25px' }}>
                    <form id="workHistoryForm" onSubmit={onSubmit}>

                        <div className="form-grid-2" style={{ alignItems: 'start' }}>
                            <div className="form-group">
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                    <label style={{ fontWeight: '500', margin: 0 }}>Từ ngày *</label>
                                    <SelectButton
                                        value={formData.StartDateAccuracy || 'date'}
                                        options={modeOptions}
                                        onChange={(e) => e.value && setFormData({ ...formData, StartDateAccuracy: e.value })}
                                        className="custom-date-toggle"
                                    />
                                </div>
                                <Calendar
                                    id="StartDate"
                                    name="StartDate"
                                    view={formData.StartDateAccuracy || 'date'}
                                    value={(formData.StartDate && !isNaN(new Date(formData.StartDate).getTime())) ? new Date(formData.StartDate) : null}
                                    dateFormat={getDateFormat(formData.StartDateAccuracy)}
                                    showIcon
                                    onChange={(e) => handleDateChange('StartDate', e.value)}
                                    style={{ width: '100%' }}
                                    appendTo={document.body}
                                    panelStyle={{ marginTop: '5px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', borderRadius: '8px', zIndex: 99999 }}
                                    inputStyle={{ padding: '10px 12px', border: '1px solid #cbd5e1', borderRight: 'none', borderRadius: '6px 0 0 6px', fontSize: '14px', outline: 'none' }}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                    <label style={{ fontWeight: '500', margin: 0 }}>Đến ngày</label>
                                    <SelectButton
                                        value={formData.EndDateAccuracy || 'date'}
                                        options={modeOptions}
                                        onChange={(e) => e.value && setFormData({ ...formData, EndDateAccuracy: e.value })}
                                        className="custom-date-toggle"
                                    />
                                </div>
                                <Calendar
                                    id="EndDate"
                                    name="EndDate"
                                    view={formData.EndDateAccuracy || 'date'}
                                    value={(formData.EndDate && !isNaN(new Date(formData.EndDate).getTime())) ? new Date(formData.EndDate) : null}
                                    dateFormat={getDateFormat(formData.EndDateAccuracy)}
                                    showIcon
                                    onChange={(e) => handleDateChange('EndDate', e.value)}
                                    style={{ width: '100%' }}
                                    appendTo={document.body}
                                    panelStyle={{ marginTop: '5px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', borderRadius: '8px', zIndex: 99999 }}
                                    inputStyle={{ padding: '10px 12px', border: '1px solid #cbd5e1', borderRight: 'none', borderRadius: '6px 0 0 6px', fontSize: '14px', outline: 'none' }}
                                />
                            </div>
                        </div>

                        <div className="form-group" style={{ marginBottom: '15px' }}>
                            <label>Nơi công tác *</label>
                            <input type="text" name="Workplace" className="form-input" value={formData.Workplace || ''} onChange={handleChange} required />
                        </div>

                        <div className="form-group" style={{ marginBottom: '15px' }}>
                            <label>Chức vụ</label>
                            <input type="text" name="Position" className="form-input" value={formData.Position || ''} onChange={handleChange} />
                        </div>

                    </form>
                </div>

                <div className="modal-footer" style={{ borderTop: '1px solid #eee' }}>
                    <button type="button" className="btn-cancel" onClick={onClose}>Hủy</button>
                    <button type="submit" form="workHistoryForm" className="btn-submit">Hoàn tất</button>
                </div>
            </div>
        </div>
    );
};

export default WorkHistoryForm;